import { Download } from 'lucide-react';
import * as XLSX from 'xlsx';

export default function ExcelTemplate () {

    const downloadTemplate = () => {
        const template = [
            {
                'Question Text': 'What is the formula for force?',
                'Question Type': 'text',
                'Diagram URL': '',
                'Option 1': 'F = ma',
                'Option 2': 'F = mv',
                'Option 3': 'F = m/a',
                'Option 4': 'F = a/m',
                'Correct Answer': '4',
                'Explanation': 'Force equals mass times acceleration',
                'Subject': 'Physics'
            },
            {
                'Question Text': 'What is the speed of light?',
                'Question Type': 'text',
                'Diagram URL': '',
                'Option 1': '3 x 10^8 m/s',
                'Option 2': '3 x 10^6 m/s',
                'Option 3': '3 x 10^10 m/s',
                'Option 4': '3 x 10^5 m/s',
                'Correct Answer': '4',
                'Explanation': 'Speed of light in vacuum is approximately 3 x 10^8 m/s',
                'Subject': 'Physics'
            },
            {
                'Question Text': 'What is H2O?',
                'Question Type': 'text',
                'Diagram URL': '',
                'Option 1': 'Oxygen',
                'Option 2': 'Water',
                'Option 3': 'Hydrogen',
                'Option 4': 'Carbon dioxide',
                'Correct Answer': '3',
                'Explanation': 'H2O is the chemical formula for water',
                'Subject': 'Chemistry'
            },
            {
                'Question Text': 'What is the pH of pure water?',
                'Question Type': 'text',
                'Diagram URL': '',
                'Option 1': '5',
                'Option 2': '7',
                'Option 3': '9',
                'Option 4': '14',
                'Correct Answer': '1',
                'Explanation': 'Pure water is neutral with pH 7',
                'Subject': 'Chemistry'
            },
            {
                'Question Text': 'What is the powerhouse of the cell?',
                'Question Type': 'text',
                'Diagram URL': '',
                'Option 1': 'Nucleus',
                'Option 2': 'Mitochondria',
                'Option 3': 'Ribosome',
                'Option 4': 'Golgi body',
                'Correct Answer': '4',
                'Explanation': 'Mitochondria produces energy for the cell',
                'Subject': 'Biology'
            }
        ];
        
        const ws = XLSX.utils.json_to_sheet(template);
        
        const colWidths = [
            { wch: 50 },
            { wch: 15 },
            { wch: 30 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 40 },
            { wch: 15 }
        ];
        ws['!cols'] = colWidths;
        
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Questions');
        XLSX.writeFile(wb, 'test_questions_template.xlsx');
    };

    return (
        <>
            <button type="button" onClick={downloadTemplate} className="px-3 py-1 text-xs text-white bg-green-600 rounded-lg hover:bg-green-700">
                <Download/>
            </button>
        </>
    )
}